export const GET_PERSONAS = "GET_PERSONAS";
export const CREATE_PERSONA = "CREATE_PERSONA";
export const DELETE_PERSONA = "DELETE_PERSONA";
export const UPDATE_PERSONA = "UPDATE_PERSONA";
export const CREATE_PERSONA_ERROR = "CREATE_PERSONA_ERROR";
